import getters from './getters';
import mutations from './mutations';
import { State } from './types';
import { getInitialState } from './utils';

const state: State = getInitialState();

export default {
  state,
  getters,
  mutations,
  namespaced: true
};
